<div class="datepicker">
  <input class="datepicker__input"
    [imask]="maskOptions"
    [unmask]="'typed'"
    [placeholder]="placeholder === undefined ? dateFormat : placeholder"
    (focus)="toggleCalendar(false)">
  @if (!isDisabled) {
    <div class="datepicker__input__calendar-icon" (click)="toggleCalendar()">
      <svg class="icon"><use xlink:href="#calendar"></use></svg>
    </div>
  }
  <ng-template templateDropdown [ngModel]="isCalendarVisible" (ngModelChange)="toggleCalendar($event)" [target]="elementRef">
    <div class="datepicker__calendar">
      <div class="datepicker__calendar__nav">
        <div class="datepicker__calendar__nav__arrow" (click)="onArrowLeftClick()">
          <svg class="icon ">
            <use xlink:href="#chevron-left"></use>
          </svg>
        </div>
        <div class="datepicker__calendar__nav__header">
          {{ currentMonth }} {{ currentYear }}
        </div>
        <div class="datepicker__calendar__nav__arrow" (click)="onArrowRightClick()">
          <svg class="icon ">
            <use xlink:href="#chevron-right"></use>
          </svg>
        </div>
      </div>
      <div class="datepicker__calendar__content">
        @for (day of dayNames; track day) {
          <div class="datepicker__calendar__label">
            {{ day }}
          </div>
        }
        <div class="datepicker__calendar__month">
          @for (day of calendarDays; track day) {
            <div
              class="datepicker__calendar__month__day {{day.styleClass}}"
              (click)="onSelectDay(day)">
              @if (day.value) {
                <span>
                  {{ day.displayValue }}
                </span>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </ng-template>
</div>
